import React from "react";

import { Field } from "react-final-form";

import DateAdapter from "../userAdapters/DateAdapter";

const DateSelectorComponent = ({ name, label, ...props }) => {
  const required = (value) => (value ? undefined : "Required");
  return (
    <Field
      {...props}
      format={(value) => (value ? new Date(value) : undefined)}
      parse={(value) => value && value?.toLocaleDateString("en-za")}
      fullWidth
      name={name}
      validate={required}
      label={label}
      component={DateAdapter}
      subscription={{
        touched: true,
        value: true,
        error: true,
        active: true,
        pristine: true,
      }}
    />
  );
};

export default DateSelectorComponent;
